<template>
  <div v-if="zones">
    <input class="input is-large" type="text" placeholder="ຄົ້ນຫາ" v-model="search" style="border-radius: 0;"/>
    <div v-for="(zone, z) in zones" :key="z">
      <div class="is-flex is-align-items-center">
        <div class="py-3 has-text-centered is-flex-grow-1 has-text-weight-bold bg-menu text-secondary"
             style="font-size: 1.3rem;">ໂຊນ : {{ zone.name }}
        </div>
      </div>
      <div class="tables">
        <template v-for="(table, index) in filteredTables">
          <div
              v-if="zone.id === table.tbl_zone_id"
              :key="index"
              class="box"
              @click="selecttable(table)"
              :class="tableClass[table.status]">
            <div style="cursor: pointer; text-align: center;">
              <b-icon icon="table-chair"/>
              <h2 class="has-text-centered has-text-weight-bold py-2" style="font-size: 1.8rem;">{{ table.name }}</h2>
              <p>({{ tableStatusName[table.status] }})</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../http";

export default {
  name: "ZoneComponent",
  props: {title: null},
  data() {
    return {
      zones: null,
      tables: null,
      table: null,
      refresh: null,
      search: null,
      tableClass: ["free", "ordered", "booked", 'paid'],
      tableStatusName: ["ວ່າງ", "ບໍ່ວ່າງ", "ຈອງແລ້ວ", "ຊໍາລະເງິນແລ້ວ"],
    };
  },
  mounted() {
    this.getzones();
    this.refresh = setInterval(() => {
      this.getzones();
    }, 5000);
  },
  beforeRouteLeave() {
    clearInterval(this.refresh);
    this.refresh = null;
  },
  beforeDestroy() {
    clearInterval(this.refresh);
    this.refresh = null;
  },
  computed: {
    filteredTables() {
      if (this.search) {
        return this.tables.filter(item => item.name.indexOf(this.search) > -1)
      }
      return this.tables
    }
  },
  methods: {
    selecttable(table) {
      clearInterval(this.refresh);
      this.$emit("selecttable", table);
    },
    getzones() {
      http.get("zones").then((res) => {
        this.zones = res;
        const myTables = [];
        for (let i = 0, len = this.zones.length; i < len; i++) {
          myTables.push(...this.zones[i].tables)
        }
        this.tables = myTables
      });
    },
  }
};
</script>
<style scoped>
.tables {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 15px;
  padding: 8px;
  margin: 8px 5px;
}

.box {
  background-color: #888888 !important;
  border-radius: 30px;
}

.box:not(last-child) {
  margin-bottom: 0;
}

.box.vip {
  border-radius: 50%;
  width: 140px;
  height: 140px;
}

.free {
  background-color: #292F43 !important;
  color: #ffffff;
}

.ordered {
  background-image: linear-gradient(to top right, #FF2F5A, #FE8382) !important;
  color: #ffffff;
}

.booked {
  background-color: #0162AB !important;
  color: #ffffff;
}

.paid {
  background-color: #45b685 !important;
  color: #ffffff;
}

u,
span {
  line-height: 80px !important;
  color: #dddddd;
}
</style>